import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProperties',
  props: {
    properties: null
  },
  setup(__props: any) {

const properties = __props as { properties: Map<string, string> }



return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(properties.properties, ([key, value]) => {
        return (_openBlock(), _createBlock(_component_q_chip, {
          clickable: "",
          onClick: ($event: any) => (_ctx.$emit('chipClicked', { key: key, value: value }))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(key) + ": " + _toDisplayString(key.endsWith('Link') ? '' : value), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 256))
    ])
  ]))
}
}

})